import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./index.css";

const TopHeader = ({ changeLn, t, setlogin, isAuthenticated }) => {
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const handleLanguageChange = (lang) => {
    setSelectedLanguage(lang);
    changeLn(lang);
    setShowLanguageMenu(false);
  };

  const navigate = useNavigate();

  const goToMyAccount = () => {
    navigate("/myAccount");
    setShowAccountMenu(false);
  };

  const handleLogin = () => {
    setlogin(true);
    setShowAccountMenu(false);
  };

  const languageOptions = [
    { value: 'en', label: 'English', flag: 'EN' },
    { value: 'jp', label: 'Japanese', flag: 'JP' }
  ];

  const currentLanguage = languageOptions.find(lang => lang.value === selectedLanguage);

  return (
    <div className="top-header">
      <div className="top-header__container">
        <div className="top-header__row">
          {/* Left Section - Contact Info */}
          <div className="top-header__left-section">
            <div className="top-header__contact-item">
              <i className="fa fa-phone top-header__icon"></i>
              <span>
                {t("callUs")}: <strong>+880 1819250309, +8802 223 311511</strong>
              </span>
            </div>
            <span className="top-header__divider">|</span>
            <div className="top-header__contact-item">
              <i className="fa fa-envelope top-header__icon"></i>
              <span>{t("email")}: info@techknowgram.com</span>
            </div>
          </div>

          {/* Right Section - User Actions */}
          <div className="top-header__right-section">
            {/* Account Dropdown */}
            <div className="top-header__dropdown">
              <button
                className={`top-header__dropdown-button ${showAccountMenu ? 'top-header__dropdown-button--active' : ''}`}
                onClick={() => setShowAccountMenu(!showAccountMenu)}
              >
                <i className="fa fa-user top-header__icon"></i>
                <span>{t("myAcc")}</span>
                <i className={`fa fa-chevron-down top-header__chevron ${showAccountMenu ? 'top-header__chevron--rotated' : ''}`}></i>
              </button>

              {showAccountMenu && (
                <div className="top-header__dropdown-menu">
                  {!isAuthenticated ? (
                    <>
                      <button
                        className="top-header__dropdown-item"
                        onClick={handleLogin}
                      >
                        <i className="fa fa-sign-in top-header__dropdown-item-icon top-header__dropdown-item-icon--login"></i>
                        Login
                      </button>
                      <button className="top-header__dropdown-item">
                        <i className="fa fa-user-plus top-header__dropdown-item-icon top-header__dropdown-item-icon--register"></i>
                        Register
                      </button>
                    </>
                  ) : (
                    <button
                      className="top-header__dropdown-item"
                      onClick={goToMyAccount}
                    >
                      <i className="fa fa-user-circle top-header__dropdown-item-icon top-header__dropdown-item-icon--account"></i>
                      My Account
                    </button>
                  )}
                </div>
              )}
            </div>

            <span className="top-header__divider">|</span>

            {/* Wishlist */}
            <div className="top-header__wishlist-item">
              <i className="fa fa-heart top-header__icon"></i>
              <span>{t("wishList")}</span>
              <span className="top-header__badge">0</span>
            </div>

            <span className="top-header__divider">|</span>

            {/* Language Dropdown */}
            <div className="top-header__dropdown">
              <button
                className={`top-header__dropdown-button ${showLanguageMenu ? 'top-header__dropdown-button--active' : ''}`}
                onClick={() => setShowLanguageMenu(!showLanguageMenu)}
              >
                <div className="top-header__language-flag">
                  {currentLanguage?.flag}
                </div>
                <span>{currentLanguage?.label}</span>
                <i className={`fa fa-chevron-down top-header__chevron ${showLanguageMenu ? 'top-header__chevron--rotated' : ''}`}></i>
              </button>

              {showLanguageMenu && (
                <div className="top-header__dropdown-menu">
                  {languageOptions.map((lang) => (
                    <button
                      key={lang.value}
                      className="top-header__dropdown-item"
                      onClick={() => handleLanguageChange(lang.value)}
                    >
                      <div className="top-header__language-flag top-header__language-flag--dropdown">
                        {lang.flag}
                      </div>
                      {lang.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Click outside handler */}
      {(showAccountMenu || showLanguageMenu) && (
        <div
          className="top-header__overlay"
          onClick={() => {
            setShowAccountMenu(false);
            setShowLanguageMenu(false);
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TopHeader);